import ComposeViewState from '../store/schema/ComposeViewState';
import { mailStore } from 'owa-mail-store';

export default function safelyGetSmartReplyExtractionId(
    composeViewState: ComposeViewState
): string {
    let extractionId: string = '';

    if (composeViewState) {
        const referenceItem = mailStore.items.get(
            composeViewState.referenceItemId && composeViewState.referenceItemId.Id
        );

        // We want to return either a valid extraction ID or an empty string, to make scorecarding easier.
        // If there is no smart reply data return empty string to make logs clean
        if (
            referenceItem &&
            referenceItem.SmartReplyData &&
            referenceItem.SmartReplyData.ExtractionID
        ) {
            extractionId = referenceItem.SmartReplyData.ExtractionID;
        }
    }

    return extractionId;
}
